import {useRef, useState} from 'react';
import {Check, Pencil, X} from 'lucide-react';
import {Button} from '@ui/shadcn/button';
import {Textarea} from '@ui/shadcn/textarea';

/** Название задачи без рамки; редактирование по карандашу остаётся частью общего черновика. */
export const TaskTitleField = ({
  value,
  onChange,
  canEdit,
  invalid,
}: {
  value: string;
  onChange: (value: string) => void;
  canEdit: boolean;
  invalid?: boolean;
}) => {
  const [editing, setEditing] = useState(false);
  const initialValue = useRef(value);
  const changed = useRef(false);
  const cancel = () => {
    if (changed.current) onChange(initialValue.current);
    setEditing(false);
  };
  if (editing && canEdit)
    return (
      <div className='flex items-start gap-1'>
        <Textarea
          autoFocus
          rows={1}
          value={value}
          maxLength={500}
          aria-label='Название задачи'
          aria-invalid={invalid}
          className='min-h-9 resize-none font-semibold leading-snug'
          onChange={(event) => {
            changed.current = true;
            onChange(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === 'Escape') {
              event.preventDefault();
              event.stopPropagation();
              cancel();
            }
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault();
              if (value.trim()) setEditing(false);
            }
          }}
        />
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='size-7 shrink-0 text-[var(--color-primary)]'
          disabled={!value.trim()}
          aria-label='Принять название'
          title='Принять название'
          onClick={() => setEditing(false)}
        >
          <Check size={14} />
        </Button>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='size-7 shrink-0'
          aria-label='Отменить изменение названия'
          title='Отмена'
          onClick={cancel}
        >
          <X size={14} />
        </Button>
      </div>
    );
  return (
    <div className='flex items-start gap-1'>
      <h2 data-heading='plain' className='min-w-0 flex-1 break-words whitespace-pre-wrap text-base font-semibold leading-snug py-0.5'>
        {value || 'Название задачи'}
      </h2>
      {canEdit && (
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='size-7 shrink-0 text-[var(--color-muted-foreground)]'
          aria-label='Редактировать название'
          title='Редактировать название'
          onClick={() => {
            initialValue.current = value;
            changed.current = false;
            setEditing(true);
          }}
        >
          <Pencil size={14} />
        </Button>
      )}
    </div>
  );
};
